module.exports = __webpack_public_path__ + "media/images/placeholder-f87d4c49f0b7dcfeba97a14c40cc3ea9.png";